import { render, staticRenderFns } from "./CadastroTarifa.vue?vue&type=template&id=38305316"
import script from "./CadastroTarifa.vue?vue&type=script&lang=js"
export * from "./CadastroTarifa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports